<section fxLayout="column" fxLayoutGap="24px" [formGroup]="pathLabelsForm">
  @if (pathLabelInformation !== null) {
    <div fxLayout="column" formGroupName="pathLabelBefore" fxLayoutGap="16px">
      <h3 class="font-weight-semibold">{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS.LABEL_BEFORE_PATH' | bmsTranslate }}</h3>

      <div class="full-width">
        <app-name-generation-pattern-new
          class="bms-theme"
          [nameGeneratorFormControl]="pathLabelsForm?.controls.pathLabelBefore.controls.nameGenerator"
          [nameGenerationProperties]="pathLabelNameGenerationProperties"
        />

        <mat-radio-group formControlName="pathLabelType" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="6.5px" fxLayoutGap.gt-sm="16px" (change)="onLabelBeforePathTypeChange($event)">
          <mat-radio-button [value]="pathLabelTypeText">
            {{ 'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.LABEL_AS_TEXT' | bmsTranslate }}
          </mat-radio-button>
          <mat-radio-button [value]="pathLabelTypeQRCode">
            {{ 'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.LABEL_AS_QR_CODE' | bmsTranslate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div fxLayout="column" formGroupName="pathLabelAfter" fxLayoutGap="16px">
      <h3 class="font-weight-semibold">{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS.LABEL_AFTER_PATH' | bmsTranslate }}</h3>

      <mat-checkbox (change)="onLabelAfterPathIsSameAsBeforeChange($event)" [disabled]="areAllFieldsDisabled" [checked]="labelAfterPathIsSameAsBeforeCheckbox">
        {{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS.LABEL_AFTER_SAME_AS_BEFORE' | bmsTranslate }}
      </mat-checkbox>

      <div *ngIf="shouldShowPathLabelAfterComponent()">
        <app-name-generation-pattern-new
          class="bms-theme"
          [nameGeneratorFormControl]="pathLabelsForm.controls.pathLabelAfter.controls.nameGenerator"
          [nameGenerationProperties]="pathLabelNameGenerationProperties"
        />

        <mat-radio-group formControlName="pathLabelType" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="6.5px" fxLayoutGap.gt-sm="16px">
          <mat-radio-button [value]="pathLabelTypeText">
            {{ 'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.LABEL_AS_TEXT' | bmsTranslate }}
          </mat-radio-button>
          <mat-radio-button [value]="pathLabelTypeQRCode">
            {{ 'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.LABEL_AS_QR_CODE' | bmsTranslate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div fxLayout="column" fxLayoutGap="16px">
      <h3 class="font-weight-semibold">{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS.LABEL_STYLE' | bmsTranslate }}</h3>

      <div class="flex-row">
        <div class="flex-column min-width-0">
          <div class="flex-row gap-16">
            <mat-form-field>
              <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
              <input matInput vdwL10nDecimal [decimals]="false" formControlName="commercialLabelHeightInMM" type="number" id="commercialLabelHeightInMM" />
              <span matSuffix>{{ 'GENERAL.UNIT.MILLIMETER' | bmsTranslate }}</span>
              <mat-error *ngIf="pathLabelsForm.get('commercialLabelHeightInMM').hasError('required')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
              <mat-error *vdwCanShowErrorForFormControl="'commercialLabelHeightInMM'; error: 'min'">
                {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: '1'} }}
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
              <input matInput vdwL10nDecimal [decimals]="false" formControlName="technicalLabelHeightInPicks" type="number" id="technicalLabelHeightInPicks" />
              <span matSuffix>
                {{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}
              </span>
              <mat-error *ngIf="pathLabelsForm.get('technicalLabelHeightInPicks').hasError('required')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
              <mat-error *vdwCanShowErrorForFormControl="'technicalLabelHeightInPicks'; error: 'min'">
                {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: machineQuality.weaveStructure.picksPerColorLine} }}
              </mat-error>
              <mat-error *ngIf="canShowMultipleError()">
                {{ 'GENERAL.ERRORS.MULTIPLE_VALUE' | bmsTranslate: {value: getMultipleValue()} }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex-row gap-16">
            <mat-form-field>
              <mat-label>{{ 'GENERAL.LABEL.FONT_FAMILY' | bmsTranslate }}</mat-label>
              <mat-select formControlName="labelFontFamily" disableOptionCentering>
                @for (fontFamily of possibleFontFamilies; track fontFamily) {
                  <mat-option [value]="fontFamily">
                    {{ 'GENERAL.FONTS.FONT_FAMILY.' + fontFamily | bmsTranslate }}
                  </mat-option>
                }
              </mat-select>
              <mat-error *ngIf="pathLabelsForm.get('labelFontFamily').hasError('required')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'GENERAL.LABEL.FONT_WEIGHT' | bmsTranslate }}</mat-label>
              <mat-select formControlName="labelFontWeight" disableOptionCentering>
                @for (fontWeight of possibleFontWeights; track fontWeight) {
                  <mat-option [value]="fontWeight">
                    {{ 'GENERAL.FONTS.FONT_WEIGHT.' + fontWeight | bmsTranslate }}
                  </mat-option>
                }
              </mat-select>
              <mat-error *ngIf="pathLabelsForm.get('labelFontWeight').hasError('required')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'GENERAL.LABEL.FONT_STYLE' | bmsTranslate }}</mat-label>
              <mat-select formControlName="labelFontStyle" disableOptionCentering>
                @for (fontStyle of possibleFontStyles; track fontStyle) {
                  <mat-option [value]="fontStyle">
                    {{ 'GENERAL.FONTS.FONT_STYLE.' + fontStyle | bmsTranslate }}
                  </mat-option>
                }
              </mat-select>
              <mat-error *ngIf="pathLabelsForm.get('labelFontStyle').hasError('required')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex-row gap-16">
            <mat-form-field class="full-width">
              <mat-label>{{ 'GENERAL.PATTERN.PATTERN' | bmsTranslate: {count: 1} }}</mat-label>
              <vdw-object-selection
                formControlName="pattern"
                [objectName]="'GENERAL.PATTERN.PATTERN' | bmsTranslate: {count: 1} | lowercase"
                [conditionalChipValueKey]="JUTE_PATTERN_CONDITIONAL_CHIP_VALUE_KEY"
                (selectClicked)="selectPattern()"
              ></vdw-object-selection>
              <mat-error *vdwCanShowErrorForFormControl="'pattern'; error: 'required'">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <app-pattern-example
              *ngIf="hasChosenPattern()"
              class="pattern-example full-width"
              [weaveQualityType]="weaveQualityType"
              [canShowColor]="true"
              [pattern]="pathLabelsForm.get('pattern').value"
              [weaveStructureId]="machineQuality.weaveStructure.id"
              [observePatternBeforeVisible]="true"
              (patternReceived)="pathZoneLoaded.emit()"
            ></app-pattern-example>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div>
      <button *appHasPermission="addPathLabelPermission" (click)="addPathLabels()" [disabled]="areAllFieldsDisabled" mat-stroked-button>
        {{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS.INSERT_PATH_LABEL' | bmsTranslate }}
      </button>
      <p *appHasNotPermission="addPathLabelPermission" class="b1 disabled">({{ 'GENERAL.HINTS.UNAUTHORIZED' | bmsTranslate }})</p>
    </div>
  }
</section>
